import { AddAgentPayoutDocumentAllowedType, DocumentType } from 'types/agent';

export const ADD_AGENT_PAYOUT_DOCUMENT_ALLOWED_TYPES: AddAgentPayoutDocumentAllowedType[] = [
  DocumentType.ACCOUNTING_NOTE_STATEMENT,
  DocumentType.EXTERNAL_INVOICE,
  DocumentType.INVOICE,
];
